/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {AvalancheWinInfo} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {GSAPUtils} from "../utils/GSAPUtils";
import {gsap} from "gsap";
import {StateMatrix} from "../utils/StateMatrix";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";

export class SushiCollectPresentation implements SimplePresentation {
    name:string = "SushiCollectPresentation";
    private roundIndex:number;

    constructor(index:number) {
        this.roundIndex = index;
    }

    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const collectedFreespinTriggerSymbols:string[] = KitchenDramaSushiMania.model.gameData.avalancheWinInfo[this.roundIndex].collectedFreespinTriggerSymbols;

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(KitchenDramaSushiMania.sushiCollectView.updateCollected(collectedFreespinTriggerSymbols));

    }
}